// Service catalogue for Neuro Rehabs

const DEFAULT_IMAGES = [
  "https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxwaHlzaW90aGVyYXB5JTIwZXhlcmNpc2UlMjByZWhhYmlsaXRhdGlvbnxlbnwwfHx8fDE3ODI2NjYxMjF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1649751361457-01d3a696c7e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxwaHlzaW90aGVyYXB5JTIwZXhlcmNpc2UlMjByZWhhYmlsaXRhdGlvbnxlbnwwfHx8fDE3ODI2NjYxMjF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1645005513713-9e2b92a687d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxwaHlzaW90aGVyYXB5JTIwZXhlcmNpc2UlMjByZWhhYmlsaXRhdGlvbnxlbnwwfHx8fDE3ODI2NjYxMjF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/30483060/pexels-photo-30483060.jpeg",
  "https://images.unsplash.com/photo-1709880754472-be89c13abc52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxwaHlzaWNhbCUyMHRoZXJhcHklMjBjbGluaWMlMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzgyNjY2MTIxfDA&ixlib=rb-4.1.0&q=85",
];

const CUSTOM_IMAGES = {
  "cervical-pain": "/service-cervical.png",
  "cupping": "/service-cupping.png",
  "hijama": "/service-hijama.png",
  "joint-pain": "/service-joint-pain.png",
  "sciatica": "/service-sciatica.png",
  "knee-pain": "/service-knee.png",
  "frozen-shoulder": "/service-frozen-shoulder.png",
  "sports-injury": "/service-sports-injury.png",
};

export const SERVICES = [
  {
    id: "back-pain",
    name: "Back Pain Treatment",
    price: 1000,
    duration: "7–15 Days",
    summary:
      "Targeted manual therapy and posture correction for chronic and acute back pain.",
    what: "Back pain is discomfort in the spine caused by poor posture, muscle strain, disc issues or prolonged sitting. It can range from a dull ache to sharp, debilitating pain that affects daily life.",
    symptoms: [
      "Lower back pain or stiffness",
      "Difficulty bending or twisting",
      "Pain while walking or standing long",
      "Radiating pain into the hips or legs",
    ],
    how: [
      "Pain reduction with manual therapy",
      "Core & muscle strengthening",
      "Posture and ergonomic improvement",
      "Mobility & flexibility recovery",
    ],
    benefits: [
      "Long-term relief without painkillers",
      "Improved posture & spinal health",
      "Faster return to daily activities",
    ],
    hi: {
      name: "कमर दर्द का इलाज",
      duration: "7–15 दिन",
      summary: "पुराने और तीव्र कमर दर्द के लिए लक्षित मैनुअल थेरेपी और पोस्चर सुधार।",
      what: "कमर दर्द खराब मुद्रा, मांसपेशियों के खिंचाव, डिस्क की समस्या या लंबे समय तक बैठने से रीढ़ में होने वाला दर्द है। यह हल्की पीड़ा से लेकर रोज़मर्रा की ज़िंदगी को प्रभावित करने वाले तेज़ दर्द तक हो सकता है।",
      symptoms: [
        "निचली कमर में दर्द या अकड़न",
        "झुकने या मुड़ने में परेशानी",
        "चलते या लंबे समय खड़े रहने पर दर्द",
        "कूल्हों या पैरों तक दर्द का फैलाव",
      ],
      how: [
        "मैनुअल थेरेपी से दर्द में कमी",
        "कोर और मांसपेशियों को मज़बूत करना",
        "मुद्रा और एर्गोनोमिक सुधार",
        "गतिशीलता और लचीलापन बहाल करना",
      ],
      benefits: [
        "दर्दनिवारक दवाओं के बिना स्थायी राहत",
        "बेहतर मुद्रा और रीढ़ का स्वास्थ्य",
        "रोज़मर्रा की गतिविधियों में जल्द वापसी",
      ],
    },
  },
  {
    id: "cervical-pain",
    name: "Cervical Pain",
    price: 700,
    duration: "7–14 Days",
    summary:
      "Relief for neck stiffness, headaches and radiating arm pain from cervical strain.",
    what: "Cervical pain affects the neck region — often caused by prolonged screen time, bad posture, cervical spondylosis or muscle spasm. It can radiate to the shoulders, arms and head.",
    symptoms: [
      "Neck stiffness and reduced rotation",
      "Headaches at the base of the skull",
      "Tingling or numbness in the arms",
      "Shoulder & upper back tightness",
    ],
    how: [
      "Cervical traction & mobilisation",
      "Neck strengthening exercises",
      "Postural re-education",
      "Trigger point release",
    ],
    benefits: [
      "Reduced headaches & neck pain",
      "Improved neck mobility",
      "Long-term posture correction",
    ],
    hi: {
      name: "सर्वाइकल दर्द",
      duration: "7–14 दिन",
      summary: "गर्दन की अकड़न, सिरदर्द और सर्वाइकल स्ट्रेन से हाथों में फैलते दर्द से राहत।",
      what: "सर्वाइकल दर्द गर्दन के क्षेत्र को प्रभावित करता है — अक्सर लंबे समय तक स्क्रीन देखने, खराब मुद्रा, सर्वाइकल स्पोंडिलोसिस या मांसपेशियों के ऐंठन से होता है। यह कंधों, बाहों और सिर तक फैल सकता है।",
      symptoms: [
        "गर्दन में अकड़न और घुमाव में कमी",
        "खोपड़ी के आधार पर सिरदर्द",
        "बाहों में झनझनाहट या सुन्नपन",
        "कंधे और ऊपरी पीठ में जकड़न",
      ],
      how: [
        "सर्वाइकल ट्रैक्शन और मोबिलाइज़ेशन",
        "गर्दन मज़बूत करने के व्यायाम",
        "मुद्रा पुनःशिक्षा",
        "ट्रिगर पॉइंट रिलीज़",
      ],
      benefits: [
        "सिरदर्द और गर्दन दर्द में कमी",
        "गर्दन की गतिशीलता में सुधार",
        "दीर्घकालिक मुद्रा सुधार",
      ],
    },
  },
  {
    id: "paralysis",
    name: "Paralysis Rehabilitation",
    price: 600,
    duration: "30–90 Days",
    summary:
      "Neuro-rehabilitation for stroke and paralysis with progressive functional recovery.",
    what: "Paralysis rehabilitation focuses on restoring movement, strength and independence in patients recovering from stroke, spinal cord injury or other neurological events.",
    symptoms: [
      "Weakness on one side of the body",
      "Loss of fine motor control",
      "Balance & coordination issues",
      "Difficulty walking or standing",
    ],
    how: [
      "Neuro-developmental therapy",
      "Gait training & balance work",
      "Strengthening & range-of-motion",
      "Functional activity retraining",
    ],
    benefits: [
      "Better independence & mobility",
      "Improved muscle tone & function",
      "Faster neurological recovery",
    ],
    hi: {
      name: "लकवा पुनर्वास",
      duration: "30–90 दिन",
      summary: "स्ट्रोक और लकवा के लिए न्यूरो-रिहैबिलिटेशन, क्रमिक कार्यात्मक सुधार के साथ।",
      what: "लकवा पुनर्वास स्ट्रोक, रीढ़ की हड्डी की चोट या अन्य न्यूरोलॉजिकल घटनाओं से उबर रहे रोगियों में गति, शक्ति और आत्मनिर्भरता बहाल करने पर केंद्रित है।",
      symptoms: [
        "शरीर के एक तरफ कमज़ोरी",
        "सूक्ष्म मोटर नियंत्रण का नुकसान",
        "संतुलन और समन्वय की समस्या",
        "चलने या खड़े होने में कठिनाई",
      ],
      how: [
        "न्यूरो-डेवलपमेंटल थेरेपी",
        "चाल प्रशिक्षण और संतुलन कार्य",
        "मज़बूती और गति की सीमा बढ़ाना",
        "कार्यात्मक गतिविधि पुनःप्रशिक्षण",
      ],
      benefits: [
        "बेहतर आत्मनिर्भरता और गतिशीलता",
        "मांसपेशियों के टोन और कार्य में सुधार",
        "तेज़ न्यूरोलॉजिकल रिकवरी",
      ],
    },
  },
  {
    id: "sports-injury",
    name: "Sports Injury Treatment",
    price: 500,
    duration: "5–21 Days",
    summary:
      "Get back in the game — recovery from sprains, strains and overuse injuries.",
    what: "Sports injury rehab addresses ligament, tendon and muscle injuries from sport and exercise — using a sport-specific, performance-oriented approach.",
    symptoms: [
      "Swelling and bruising",
      "Sharp pain on movement",
      "Reduced strength or speed",
      "Joint instability",
    ],
    how: [
      "RICE protocol & ice/heat therapy",
      "Sport-specific strengthening",
      "Taping & joint stabilisation",
      "Return-to-play conditioning",
    ],
    benefits: [
      "Faster return to sport",
      "Reduced re-injury risk",
      "Restored athletic performance",
    ],
    hi: {
      name: "खेल चोट का इलाज",
      duration: "5–21 दिन",
      summary: "खेल में वापसी — मोच, खिंचाव और अति प्रयोग की चोटों से रिकवरी।",
      what: "खेल चोट पुनर्वास खेल और व्यायाम से हुई लिगामेंट, टेंडन और मांसपेशियों की चोटों को ठीक करता है — खेल-विशिष्ट, प्रदर्शन-केंद्रित दृष्टिकोण से।",
      symptoms: [
        "सूजन और नील पड़ना",
        "हरकत पर तेज़ दर्द",
        "ताकत या गति में कमी",
        "जोड़ों में अस्थिरता",
      ],
      how: [
        "RICE प्रोटोकॉल और बर्फ/गर्मी थेरेपी",
        "खेल-विशिष्ट मज़बूतीकरण",
        "टेपिंग और जोड़ स्थिरीकरण",
        "खेल में वापसी की कंडीशनिंग",
      ],
      benefits: [
        "खेल में तेज़ वापसी",
        "दोबारा चोट का खतरा कम",
        "एथलेटिक प्रदर्शन बहाल",
      ],
    },
  },
  {
    id: "joint-pain",
    name: "Joint Pain Therapy",
    price: 500,
    duration: "10–21 Days",
    summary:
      "Targeted therapy for arthritis, stiffness and inflammation in major joints.",
    what: "Joint pain therapy treats stiffness, swelling and pain in joints — commonly caused by arthritis, overuse or age-related wear and tear.",
    symptoms: [
      "Morning stiffness in joints",
      "Pain on climbing stairs",
      "Swelling around the joint",
      "Reduced range of motion",
    ],
    how: [
      "Joint mobilisation techniques",
      "Strengthening of supporting muscles",
      "Heat / cold therapy",
      "Functional movement retraining",
    ],
    benefits: [
      "Less pain & better mobility",
      "Slowed progression of arthritis",
      "Improved daily comfort",
    ],
    hi: {
      name: "जोड़ों के दर्द की थेरेपी",
      duration: "10–21 दिन",
      summary: "प्रमुख जोड़ों में गठिया, अकड़न और सूजन के लिए लक्षित थेरेपी।",
      what: "जोड़ों के दर्द की थेरेपी जोड़ों में अकड़न, सूजन और दर्द का इलाज करती है — जो आमतौर पर गठिया, अति प्रयोग या उम्र से जुड़े घिसाव से होता है।",
      symptoms: [
        "सुबह जोड़ों में अकड़न",
        "सीढ़ियाँ चढ़ने पर दर्द",
        "जोड़ के आस-पास सूजन",
        "गति की सीमा में कमी",
      ],
      how: [
        "जोड़ मोबिलाइज़ेशन तकनीक",
        "सहायक मांसपेशियों को मज़बूत करना",
        "गर्मी / ठंड की थेरेपी",
        "कार्यात्मक गतिविधि पुनःप्रशिक्षण",
      ],
      benefits: [
        "कम दर्द और बेहतर गतिशीलता",
        "गठिया की प्रगति धीमी",
        "दैनिक आराम में सुधार",
      ],
    },
  },
  {
    id: "cupping",
    name: "Cupping Therapy",
    price: 600,
    duration: "Per Session / 5–10 Sessions",
    summary:
      "Traditional cupping to release muscle tension and improve circulation.",
    what: "Cupping is a time-tested therapy that uses suction cups on the skin to relieve muscle tightness, boost blood flow and accelerate recovery.",
    symptoms: [
      "Chronic muscle knots",
      "Stiff shoulders & back",
      "Slow recovery after workouts",
      "Localised pain points",
    ],
    how: [
      "Dry & wet cupping techniques",
      "Trigger point decompression",
      "Improved blood circulation",
      "Combined with manual therapy",
    ],
    benefits: [
      "Released muscle tension",
      "Better blood flow & recovery",
      "Reduced chronic pain",
    ],
    hi: {
      name: "कपिंग थेरेपी",
      duration: "प्रति सेशन / 5–10 सेशन",
      summary: "मांसपेशियों का तनाव दूर करने और रक्त संचार सुधारने के लिए पारंपरिक कपिंग।",
      what: "कपिंग एक समय-परीक्षित थेरेपी है जो त्वचा पर सक्शन कप का उपयोग करके मांसपेशियों की जकड़न दूर करती है, रक्त प्रवाह बढ़ाती है और रिकवरी तेज़ करती है।",
      symptoms: [
        "पुरानी मांसपेशियों की गांठें",
        "कंधों और पीठ में अकड़न",
        "वर्कआउट के बाद धीमी रिकवरी",
        "स्थानीय दर्द बिंदु",
      ],
      how: [
        "ड्राई और वेट कपिंग तकनीक",
        "ट्रिगर पॉइंट डिकंप्रेशन",
        "रक्त संचार में सुधार",
        "मैनुअल थेरेपी के साथ संयोजन",
      ],
      benefits: [
        "मांसपेशियों का तनाव मुक्त",
        "बेहतर रक्त प्रवाह और रिकवरी",
        "पुराने दर्द में कमी",
      ],
    },
  },
  {
    id: "hijama",
    name: "Hijama Therapy",
    price: 800,
    duration: "Per Session",
    summary:
      "Therapeutic Hijama in a hygienic, doctor-supervised home environment.",
    what: "Hijama (wet cupping) is a traditional therapy used to detoxify the body, relieve pain and address a wide range of chronic conditions in a hygienic setup.",
    symptoms: [
      "Chronic fatigue or headaches",
      "Persistent back & shoulder pain",
      "Stress & body stiffness",
      "Slow healing or recovery",
    ],
    how: [
      "Sterile, single-use equipment",
      "Doctor-supervised technique",
      "Targeted pressure-point therapy",
      "Personalised session count",
    ],
    benefits: [
      "Improved energy & wellbeing",
      "Pain & tension relief",
      "Holistic, doctor-led care",
    ],
    hi: {
      name: "हिजामा थेरेपी",
      duration: "प्रति सेशन",
      summary: "स्वच्छ, डॉक्टर की देखरेख में घरेलू वातावरण में चिकित्सीय हिजामा।",
      what: "हिजामा (वेट कपिंग) एक पारंपरिक थेरेपी है जो शरीर को डिटॉक्स करने, दर्द से राहत देने और स्वच्छ वातावरण में विभिन्न पुरानी स्थितियों का इलाज करने के लिए उपयोग की जाती है।",
      symptoms: [
        "पुरानी थकान या सिरदर्द",
        "लगातार कमर और कंधे का दर्द",
        "तनाव और शरीर में अकड़न",
        "धीमी रिकवरी या उपचार",
      ],
      how: [
        "स्टेराइल, एकल-उपयोग उपकरण",
        "डॉक्टर की देखरेख में तकनीक",
        "लक्षित प्रेशर-पॉइंट थेरेपी",
        "व्यक्तिगत सेशन संख्या",
      ],
      benefits: [
        "बेहतर ऊर्जा और कल्याण",
        "दर्द और तनाव से राहत",
        "समग्र, डॉक्टर-नेतृत्व देखभाल",
      ],
    },
  },
  {
    id: "sciatica",
    name: "Sciatica Treatment",
    price: 600,
    duration: "10–21 Days",
    summary:
      "End the burning, radiating pain down your leg with targeted nerve-release therapy.",
    what: "Sciatica is pain radiating along the path of the sciatic nerve — from the lower back through the hips and down each leg, often caused by a herniated disc or piriformis syndrome.",
    symptoms: [
      "Burning pain from back to leg",
      "Numbness or tingling in the leg",
      "Weakness in the leg or foot",
      "Pain worsening on sitting",
    ],
    how: [
      "Nerve gliding & flossing techniques",
      "Lumbar traction therapy",
      "Core stabilisation exercises",
      "Posture & ergonomics correction",
    ],
    benefits: [
      "Lasting nerve pain relief",
      "Improved walking & sitting tolerance",
      "Avoid surgical intervention",
    ],
    hi: {
      name: "साइटिका का इलाज",
      duration: "10–21 दिन",
      summary: "लक्षित नर्व-रिलीज़ थेरेपी से पैर में फैलते जलन भरे दर्द को खत्म करें।",
      what: "साइटिका साइटिक नर्व के रास्ते में फैलने वाला दर्द है — निचली कमर से कूल्हों से होते हुए हर पैर तक, अक्सर हर्निएटेड डिस्क या पिरिफॉर्मिस सिंड्रोम से होता है।",
      symptoms: [
        "कमर से पैर तक जलन भरा दर्द",
        "पैर में सुन्नपन या झनझनाहट",
        "पैर या पैर के पंजे में कमज़ोरी",
        "बैठने पर दर्द बढ़ना",
      ],
      how: [
        "नर्व ग्लाइडिंग और फ्लॉसिंग तकनीक",
        "लम्बर ट्रैक्शन थेरेपी",
        "कोर स्टेबिलाइज़ेशन व्यायाम",
        "मुद्रा और एर्गोनोमिक्स सुधार",
      ],
      benefits: [
        "स्थायी नर्व दर्द राहत",
        "चलने और बैठने की सहनशीलता में सुधार",
        "सर्जिकल हस्तक्षेप से बचाव",
      ],
    },
  },
  {
    id: "knee-pain",
    name: "Knee Pain Therapy",
    price: 600,
    duration: "10–21 Days",
    summary:
      "Strengthen, stabilise and protect your knees — for sport and daily life.",
    what: "Knee pain therapy treats pain from ligament injuries, osteoarthritis, meniscus issues and overuse — restoring strength and stability.",
    symptoms: [
      "Pain on climbing stairs",
      "Knee swelling or locking",
      "Instability while walking",
      "Stiffness after rest",
    ],
    how: [
      "Quadriceps & hamstring strengthening",
      "Patellar mobilisation",
      "Balance & proprioception training",
      "Bracing & taping if needed",
    ],
    benefits: [
      "Pain-free movement",
      "Stronger, more stable knees",
      "Delayed need for surgery",
    ],
    hi: {
      name: "घुटने के दर्द की थेरेपी",
      duration: "10–21 दिन",
      summary: "घुटनों को मज़बूत, स्थिर और सुरक्षित बनाएं — खेल और दैनिक जीवन के लिए।",
      what: "घुटने के दर्द की थेरेपी लिगामेंट चोट, ऑस्टियोआर्थराइटिस, मेनिस्कस समस्या और अति प्रयोग से होने वाले दर्द का इलाज करती है — ताकत और स्थिरता बहाल करती है।",
      symptoms: [
        "सीढ़ियाँ चढ़ने पर दर्द",
        "घुटने में सूजन या लॉकिंग",
        "चलते समय अस्थिरता",
        "आराम के बाद अकड़न",
      ],
      how: [
        "क्वाड्रिसेप्स और हैमस्ट्रिंग मज़बूतीकरण",
        "पटेलर मोबिलाइज़ेशन",
        "संतुलन और प्रोप्रियोसेप्शन प्रशिक्षण",
        "ज़रूरत पड़ने पर ब्रेसिंग और टेपिंग",
      ],
      benefits: [
        "दर्द-मुक्त गति",
        "मज़बूत और स्थिर घुटने",
        "सर्जरी की ज़रूरत में देरी",
      ],
    },
  },
  {
    id: "frozen-shoulder",
    name: "Frozen Shoulder Treatment",
    price: 500,
    duration: "21–45 Days",
    summary:
      "Restore full shoulder range and end the stiffness that limits daily life.",
    what: "Frozen shoulder (adhesive capsulitis) causes pain and severe stiffness in the shoulder joint, often developing gradually and lasting months without treatment.",
    symptoms: [
      "Difficulty raising the arm",
      "Pain at night while sleeping",
      "Stiffness while dressing",
      "Reduced shoulder rotation",
    ],
    how: [
      "Capsular stretching techniques",
      "Joint mobilisation",
      "Range-of-motion exercises",
      "Strength rebuilding",
    ],
    benefits: [
      "Restored shoulder mobility",
      "Pain-free sleep",
      "Return to full daily function",
    ],
    hi: {
      name: "फ्रोज़न शोल्डर का इलाज",
      duration: "21–45 दिन",
      summary: "कंधे की पूरी रेंज बहाल करें और दैनिक जीवन को सीमित करने वाली अकड़न खत्म करें।",
      what: "फ्रोज़न शोल्डर (एडहेसिव कैप्सुलाइटिस) कंधे के जोड़ में दर्द और गंभीर अकड़न का कारण बनता है, अक्सर धीरे-धीरे विकसित होता है और बिना इलाज के महीनों तक रह सकता है।",
      symptoms: [
        "हाथ उठाने में परेशानी",
        "रात को सोते समय दर्द",
        "कपड़े पहनते समय अकड़न",
        "कंधे के घुमाव में कमी",
      ],
      how: [
        "कैप्सुलर स्ट्रेचिंग तकनीक",
        "जोड़ मोबिलाइज़ेशन",
        "गति की सीमा के व्यायाम",
        "ताकत पुनर्निर्माण",
      ],
      benefits: [
        "कंधे की गतिशीलता बहाल",
        "दर्द-मुक्त नींद",
        "पूर्ण दैनिक कार्य में वापसी",
      ],
    },
  },
].map((s, i) => ({ ...s, image: CUSTOM_IMAGES[s.id] || DEFAULT_IMAGES[i % DEFAULT_IMAGES.length] }));

export const getServiceById = (id) => SERVICES.find((s) => s.id === id);
